import { useDriveSpace } from "../../Hooks/Features/Inspectra/useDriveSpace";
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { Dialog } from 'primereact/dialog';
import { SkeletonContainer } from "../Loader/Loader.jsx";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DriveSpace = ({ projectChanged }) => {

    const { options, showPopup, setShowPopup, popupData, loader, showFilter, setShowFilter, filterOpts, filterValues, setFilterValues, filterCount, expand, setExpand, handleApplyFilters } = useDriveSpace({ projectChanged });

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Drive Space Status</div>
                <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center" onClick={() => setShowFilter(true)}><span className="inspectra-filter-count">{filterCount}</span>filters</div>
            </div>
            <div className="inspectra-widget-content">
                {loader ? <SkeletonContainer /> :
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                }
            </div>

            <div className="position-absolute bottom-0 end-0 me-1 fs-6 c-pointer" onClick={() => setExpand(true)}>
                <FontAwesomeIcon icon="fa-solid fa-expand" />
            </div>

            <Dialog visible={showFilter} onHide={() => setShowFilter(false)} className="modal-small" draggable={false} header="Drive Space Status Filters">
                <div>
                    <div className="d-flex gap-2">
                        <div className="w50">
                            <div>Server:</div>
                            <MultiSelect options={filterOpts?.server} placeholder="Server" value={filterValues?.server} onChange={(e) => setFilterValues((prev) => ({ ...prev, server: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'server', filterValues?.server, () => setFilterValues((prev) => ({ ...prev, server: [] })))} filter filterInputAutoFocus />
                        </div>
                        <div className="w50">
                            <div>Drive:</div>
                            <MultiSelect options={filterOpts?.drive} placeholder="Drive" value={filterValues?.drive} onChange={(e) => setFilterValues((prev) => ({ ...prev, drive: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'drive', filterValues?.drive, () => setFilterValues((prev) => ({ ...prev, drive: [] })))} filter filterInputAutoFocus />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary c-pointer" onClick={() => setFilterValues((prev) => ({ ...prev, server: [], drive: [] }))}>Select default filters</div>
                        <button className="button btn-primary" onClick={() => handleApplyFilters()}>Apply</button>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showPopup} onHide={() => setShowPopup(false)} draggable={false} className='modal-large inspectra-grey-dialog' header="Drive Space Details">
                <div>
                    <div className="inspectra-popup-card">
                        <div className="d-flex mb-1">
                            <div className="w30 fw-bold">Project Name:</div>
                            <div className="w70 text-wrap">{popupData?.project_name}</div>
                        </div>

                        <div className="d-flex mb-1">
                            <div className="w30 fw-bold">Drive Name:</div>
                            <div className="w70 text-wrap">{popupData?.drive_name || popupData?.DriveName}</div>
                        </div>

                        <div className="d-flex mb-1">
                            <div className="w30 fw-bold">Server:</div>
                            <div className="w70 text-wrap">{popupData?.server}</div>
                        </div>

                        <div className="d-flex mb-1">
                            <div className="w30 fw-bold">Used:</div>
                            <div className="w70 text-wrap">{popupData?.used?.includes("T") ? popupData?.used?.split("T")?.[0] + " TB" : popupData?.used?.includes("G") ? popupData?.used?.split("G")?.[0] + " GB" : popupData?.used?.includes("M") ? popupData?.used?.split("M")?.[0] + " MB" : popupData?.used + " MB"}</div>
                        </div>

                        <div className="d-flex mb-1">
                            <div className="w30 fw-bold">Available:</div>
                            <div className="w70 text-wrap">{popupData?.available?.includes("T") ? popupData?.available?.split("T")?.[0] + " TB" : popupData?.available?.includes("G") ? popupData?.available?.split("G")?.[0] + " GB" : popupData?.available?.includes("M") ? popupData?.available?.split("M")?.[0] + " MB" : popupData?.available + " MB"}</div>
                        </div>

                        <div className="d-flex mb-1">
                            <div className="w30 fw-bold">Total:</div>
                            <div className="w70 text-wrap">{popupData?.size?.includes("T") ? popupData?.size?.split("T")?.[0] + " TB" : popupData?.size?.includes("G") ? popupData?.size?.split("G")?.[0] + " GB" : popupData?.size?.includes("M") ? popupData?.size?.split("M")?.[0] + " MB" : popupData?.size + " MB"}</div>
                        </div>

                        <div className="d-flex mb-1">
                            <div className="w30 fw-bold">Percentage Use:</div>
                            <div className="w70 text-wrap">{popupData?.use_perc}</div>
                        </div>

                        <div className="d-flex mb-1">
                            <div className="w30 fw-bold">Create Date:</div>
                            <div className="w70 text-wrap">{new Date(popupData?.create_date).toLocaleString()}</div>
                        </div>

                    </div>
                </div>
            </Dialog>

            <Dialog visible={expand} onHide={() => setExpand(false)} className="modal-xlarge" draggable={false} header="Drive Space Status Expanded">
                <div>
                    <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center justify-content-end" onClick={() => setShowFilter(true)}>
                        <span className="inspectra-filter-count">{filterCount}</span>filters
                    </div>
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                </div>
            </Dialog>
        </div>
    )
}

export default DriveSpace